<script>
export default {

    data () {
        return {
            currentPicture:null,
        }
    },

    methods: {
        handlePicture(e) {
            this.form.photo = e.target.files[0];
            this.currentPicture = this.form.photo
        },
    }
}   
</script>